import type { ReactNode } from 'react';

// 'card' stands alone (the wizard review); 'section' is one part of a single surface, split by dividers.
type RecapPanelVariant = 'card' | 'section';

const PANEL_CLASS: Readonly<Record<RecapPanelVariant, string>> = {
    card: 'rounded-xl border border-gray-200 bg-white p-4',
    section: 'py-5 border-t border-gray-100 first:border-t-0'
};

const TITLE_CLASS = 'text-xs font-semibold text-gray-400 uppercase tracking-wider';

interface RecapPanelProps {
    title: string;
    variant?: RecapPanelVariant;
    action?: ReactNode;
    children: ReactNode;
}

export function RecapPanel({ title, variant = 'card', action, children }: RecapPanelProps) {
    return (
        <div className={PANEL_CLASS[variant]}>
            {action ? (
                <div className="flex items-center justify-between gap-3 min-h-[28px] mb-2">
                    <div className={TITLE_CLASS}>{title}</div>
                    {action}
                </div>
            ) : (
                <div className={`${TITLE_CLASS} mb-2`}>{title}</div>
            )}
            {children}
        </div>
    );
}

interface RecapRowProps {
    label: ReactNode;
    value: ReactNode;
}

export function RecapRow({ label, value }: RecapRowProps) {
    return (
        <div className="flex items-baseline justify-between gap-3 text-sm py-0.5">
            <span className="text-gray-500">{label}</span>
            <span className="text-gray-800 text-right">
                {value || <span className="text-gray-400 italic">-</span>}
            </span>
        </div>
    );
}

export function RecapEmpty({ children }: { children: ReactNode }) {
    return <div className="text-sm text-gray-400 italic">{children}</div>;
}
